import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useFetch } from '../../hooks/useFetch';
import { useEffect, useState } from 'react';
import {
  Container,
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Divider,
  Card,
  Paper,
  CardActions,
  CardContent,
} from '@mui/material/';
import format from 'date-fns/format';
import EditIcon from '@mui/icons-material/Edit';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DataGridView from '../../components/DataGridView';
import PageviewIcon from '@mui/icons-material/Pageview';
import PreviewIcon from '@mui/icons-material/Preview';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import DescriptionIcon from '@mui/icons-material/Description';
import clsx from 'clsx';
import SearchBar from '../SearchBar';
import AddIcon from '@mui/icons-material/Add';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
function ViewExamsList({ sessionId, studentId, setExamId, setAddAuth, catId }) {
  const [tableData, setTableData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const {
    postData,
    error,
    isPending,
    data: examlist,
  } = useFetch('https://pcapi.bi-oss.co.za/studcambridge/examinationlist');

  const handleOnCellClick = (e) => {
    // window.open(e.row.fileURL, '_blank')
  };
  useEffect(() => {
    if (sessionId) {
      postData({
        sessionId,
        studentId,
        campusId: 6,
        academicYear: new Date().getFullYear(),
      });
    }
  }, [sessionId]);

  useEffect(
    (tableData) => {
      if (examlist) {
        setTableData(examlist);
      }
    },
    [examlist],
  );

  const columns = [
    {
      field: 'qualification',
      headerName: 'Qualification:',
      width: 120,
      editable: true,
    },
    { field: 'camCode', headerName: 'Course:', width: 100, editable: true },
    {
      field: 'paperCode',
      headerName: 'Paper Combination:',
      width: 150,
      editable: true,
    },
    {
      field: 'description',
      headerName: 'Paper Description:',
      width: 350,
      editable: true,
    },

    {
      field: 'action1',
      headerName: 'Action',
      width: 150,
      renderCell: (params) => {
        const onClick1 = (e) => {
          e.stopPropagation(); // don't select this row after clicking

          setExamId(params.row.id);
          setAddAuth(1);
        };

        if (params.row.inCart === true && params.row.ExamPaid === false)
          return (
            <Button color="primary" disabled fullWidth variant="contained">
              In Cart
            </Button>
          );
        if (params.row.inCart === true && params.row.ExamPaid === true)
          return (
            <Button color="error" disabled fullWidth variant="contained">
              PAID
            </Button>
          );

        if (params.row.inCart === false)
          return (
            <Button
              color="primary"
              onClick={onClick1}
              fullWidth
              variant="contained"
            >
              Add
              <AddShoppingCartIcon />
            </Button>
          );
      },
    },
  ];

  const [searchColumns, setSearchColumns] = useState(['qualificationId']);
  function search(rows) {
    return rows.filter((row) =>
      searchColumns.some(
        (column) => row[column].toString().toLowerCase().indexOf(catId) > -1,
      ),
    );
  }

  const [searchColumns2, setSearchColumns2] = useState([
    'camCode',
    'paperCode',
    'description',
  ]);

  function search2(rows) {
    return rows.filter((row) =>
      searchColumns2.some(
        (column) =>
          row[column]
            .toString()
            .toLowerCase()
            .indexOf(searchText.toLowerCase()) > -1,
      ),
    );
  }

  useEffect(() => {
    if (catId) {
      setSearchText('');
    }
  }, [catId]);

  return (
    <>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
      >
        {isPending && (
          <Grid item xs={12}>
            <Box
              sx={{
                height: 300,
                width: '100%',

                '.negative': {
                  backgroundColor: 'rgba(157, 255, 118, 0.49)',
                  color: '#1a3e72',
                  fontWeight: '600',
                },
                '.positive': {
                  backgroundColor: '#d47483',
                  color: '#1a3e72',
                  fontWeight: '600',
                },
              }}
            >
              <Typography variant="h6" component="h3" color="primary.main">
                Fetching examination list ...
              </Typography>
            </Box>
          </Grid>
        )}

        {!isPending && !error && tableData && tableData.length > 0 && (
          <>
            <Grid item xs={12} minWidth={0}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <SearchBar
                  searchText={searchText}
                  setSearchText={setSearchText}
                  labeltext="Search examinations...."
                />
              </Box>
            </Grid>

            <Grid item xs={12} minWidth={0}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <DataGridView
                  tableData={search(search2(tableData))}
                  error={error}
                  isPending={isPending}
                  getFormattedDate={null}
                  columns={columns}
                  pageSize={30}
                  handleOnCellClick={handleOnCellClick}
                  getRowId={(row) => row.id}
                  fullWidth
                />
              </Box>
            </Grid>
          </>
        )}

        {!isPending && !error && tableData && tableData.length === 0 && (
          <Grid item xs={12} minWidth={0}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Typography variant="body2" component="p" color="primary">
                <b>
                  There are currently no examinations available for the selected
                  qualification.
                </b>
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default ViewExamsList;
